import React, { useState } from 'react';

const CustomDetails = ({ details, type }) => {
	const [isAddressOpen, setIsAddressOpen] = useState(false);

	const addressToggleDropdown = () => {
		setIsAddressOpen(!isAddressOpen);
	};

	return (
		<div>
			{type === 'customer' && (
				<div
					className="d-flex"
					style={{ gap: '50px' }}
				>
					<div style={{ marginLeft: '18px' }}>
						<div style={{ color: '#000', fontSize: '17px' }}>Total Outstanding</div>
						<div
							style={{
								color: '#000',
								fontSize: '18px',
								fontWeight: '600',
								lineHeight: '30px',
								textAlign: 'center',
							}}
						>
							INR {details?.total_outstanding}
						</div>
					</div>
					<div style={{ borderRight: '1px solid #C3CBDC' }}></div>
					<div>
						<div style={{ color: '#000', fontSize: '17px' }}>Total Credits</div>
						<div
							style={{
								color: '#000',
								fontSize: '18px',
								fontWeight: '600',
								lineHeight: '30px',
								textAlign: 'center',
							}}
						>
							INR {details?.total_credit_amount || 0}
						</div>
					</div>
				</div>
			)}
			<br />

			<div
				style={{
					border: '1px solid #D0D0D0',
					borderRadius: '8px',
					padding: '16px',
					maxWidth: '100%',
				}}
			>
				<div style={{ display: 'flex' }}>
					<div>
						<h3
							style={{
								borderBottom: '1px solid #D0D0D0',
								paddingBottom: '8px',
								fontWeight: '600',
								width: '405px',
							}}
						>
							Contact Details
						</h3>
						<div style={{ marginBottom: '12px' }}>
							<div className="ListQ">{type === 'customer' ? 'Customer Type' : 'Doctor Type'}</div>
						</div>
						{type === 'doctor' && (
							<div style={{ marginBottom: '12px' }}>
								<div className="ListQ">Registration Number</div>
							</div>
						)}
						<div style={{ marginBottom: '12px' }}>
							<div className="ListQ">{type === 'customer' ? 'Company Name' : 'Business Name'}</div>
						</div>
						{type === 'customer' && (
							<div style={{ marginBottom: '12px' }}>
								<div className="ListQ">PAN</div>
							</div>
						)}
						{type === 'customer' && (
							<div style={{ marginBottom: '12px' }}>
								<div className="ListQ">GSTIN</div>
							</div>
						)}
						<div style={{ marginBottom: '12px' }}>
							<div className="ListQ">Currency</div>
						</div>
						{type === 'customer' && (
							<div style={{ marginBottom: '12px' }}>
								<div className="ListQ">Credit Days</div>
							</div>
						)}
					</div>

					<div style={{ marginTop: '36px', marginLeft: '-256px' }}>
						<div style={{ marginBottom: '12px' }}>
							{type === 'doctor'
								? `${details?.doctor_type?.name || ''}`
								: `${details.type === '0' ? 'Individual' : 'Business'}`}
						</div>
						{type === 'doctor' && (
							<div style={{ marginBottom: '12px' }}>{details?.registration_number}</div>
						)}

						<div style={{ marginBottom: '12px' }}>
							{type === 'customer'
								? details?.customer_business?.name || 'Not Available'
								: details.business_name || 'Not Available'}
						</div>

						{type === 'customer' && (
							<div style={{ marginBottom: '12px' }}>{details?.pan || 'Not Available'}</div>
						)}
						{type === 'customer' && (
							<div style={{ marginBottom: '12px' }}>
								{details?.customer_business?.gst_number || 'Not Available'}
							</div>
						)}
						<div style={{ marginBottom: '12px' }}>INR</div>
						{type === 'customer' && (
							<div style={{ marginBottom: '12px' }}>{details?.credit_days || 0}</div>
						)}
					</div>
				</div>
			</div>
			<br />
			<div className="contact-card">
				<div
					className="dropdown-header"
					onClick={addressToggleDropdown}
				>
					<h3 style={{ fontWeight: '600', fontSize: '16px', color: '#000' }}>Address</h3>
					<span>{isAddressOpen ? '▲' : '▼'}</span>
				</div>

				{isAddressOpen && (
					<div className="contact-details">
						<div style={{ borderLeft: '1px solid black', padding: '5px', color: '#555b67' }}>
							<div>{details?.attention || 'N/A'}</div>
							<div>{details?.city?.name || 'N/A'}</div>
							<div>{details?.street1 || details?.street_1 || 'N/A'}</div>
							<div>{details?.street2 || details?.street_2 || 'N/A'}</div>
							<div>{details?.state?.name || details?.street_2 || 'N/A'}</div>
							<div>{details?.zipcode || 'N/A'}</div>
							<div>{details?.country?.name || 'N/A'}</div>
						</div>
					</div>
				)}
			</div>

			<br />
			<br />
		</div>
	);
};

export default CustomDetails;
